import { Snackbar, SnackbarProps } from '@mui/base/Snackbar';
import { FC, useCallback, useMemo, useRef, useState } from 'react';
import { Transition } from 'react-transition-group';

const positioningStyles = {
  entering: 'translateX(0)',
  entered: 'translateX(0)',
  exiting: 'translateX(500px)',
  exited: 'translateX(500px)',
  unmounted: 'translateX(500px)'
};

interface ErrorSnackbarProps extends SnackbarProps {
  error: unknown;
}

export const ErrorSnackbar: FC<ErrorSnackbarProps> = props => {
  const { error, ...otherProps } = props;
  const nodeRef = useRef(null);

  const [exited, setExited] = useState(true);
  const handleOnEnter = useCallback(() => {
    setExited(false);
  }, []);
  const handleOnExited = useCallback(() => {
    setExited(true);
  }, []);

  // TODO: fix API transformResponseError to return an error object
  const { title, message } = useMemo(() => {
    if (typeof error === 'string') {
      return {
        message: error
      };
    }

    /* eslint-disable @typescript-eslint/no-explicit-any */
    /* eslint-disable-next-line @typescript-eslint/no-unsafe-member-access */
    const message = (error as any)?.data?.message as string | undefined;

    /* eslint-enable @typescript-eslint/no-explicit-any */
    return {
      title: 'Error occurred',
      message: message ?? 'Unknown error occurred'
    };
  }, [error]);

  return (
    <Snackbar
      {...otherProps}
      autoHideDuration={5000}
      exited={exited}
      className="fixed bottom-4 left-auto right-4 z-50 flex max-w-xl font-sans"
    >
      <Transition
        timeout={{ enter: 400, exit: 400 }}
        in={props.open}
        appear
        unmountOnExit
        onEnter={handleOnEnter}
        onExited={handleOnExited}
        nodeRef={nodeRef}
      >
        {status => (
          <div
            className="flex gap-4	overflow-hidden	rounded-lg border border-solid	border-slate-200 bg-white p-3 text-start text-slate-900 shadow-md dark:border-slate-700 dark:bg-slate-900	dark:text-slate-50"
            style={{
              transform: positioningStyles[status],
              transition: 'transform 300ms ease'
            }}
            ref={nodeRef}
          >
            <div className="max-w-full flex-1">
              <p className="m-0 mr-2 font-medium leading-normal">{title}</p>
              <p className="m-0 font-normal leading-normal text-slate-800 dark:text-slate-400">
                {message}
              </p>
            </div>
          </div>
        )}
      </Transition>
    </Snackbar>
  );
};
